import { render, staticRenderFns } from "./candidate-form.vue?vue&type=template&id=5fe88c7f&"
import script from "./candidate-form.vue?vue&type=script&lang=js&"
export * from "./candidate-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports